import React from "react";

const ViewProcessedOrders = () => {
  return <div></div>;
};

export default ViewProcessedOrders;
